var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Lorem ipsum dolor sit, amet consectetur adipisicing elit. Illum obcaecati at saepe neque atque pariatur mollitia, exercitationem iusto sunt fugiat aspernatur, cupiditate culpa, voluptatibus dignissimos nisi magnam nemo? Officia, aliquid? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }